export default {
  // Navigation
  'muse.nav.workspace': 'Workspace',
  'muse.nav.voice': 'Voice',
  'muse.nav.voiceTemplate': 'Voice Templates',
  'muse.nav.voiceSynth': 'Voice Synthesis',
  'muse.nav.video': 'Video',
  'muse.nav.avatar': 'Avatars',
  'muse.nav.avatarGenerate': 'Avatar Generation',
  'muse.nav.adminDashboard': 'Dashboard',
  'muse.nav.adminAvatar': 'Platform Avatars',
  'muse.nav.adminTask': 'Tasks',
  'muse.nav.adminModel': 'API Config',
  'muse.nav.adminPricing': 'Billing',

  // Home (intro page)
  'muse.intro.pageTitle': 'AI Voice & Digital Human Video Studio',
  'muse.intro.login': 'Sign in',
  'muse.intro.start': 'Get started',
  'muse.intro.nav.features': 'Features',
  'muse.intro.nav.voice': 'Voice',
  'muse.intro.nav.video': 'Video',
  'muse.intro.nav.ways': 'Integrations',
  'muse.intro.nav.menu': 'Menu',
  'muse.intro.badge': 'AI voice · digital human video',
  'muse.intro.hero.titleLead': 'Give every idea',
  'muse.intro.hero.titleAccent': 'a voice and a face',
  'muse.intro.hero.subtitle': 'From a line of copy to a publish-ready digital human video: voice synthesis, voice cloning and avatar generation in one workspace.',
  'muse.intro.hero.ctaPublic': 'Start creating for free',
  'muse.intro.hero.ctaApp': 'Open workspace',
  'muse.intro.hero.secondaryPublic': 'Explore features',
  'muse.intro.hero.imageAlt': 'Digital human preview with an audio sample',
  'muse.intro.hero.note': 'No editing experience · multilingual voices · API access',
  'muse.intro.hero.noteNoEdit': 'No editing experience',
  'muse.intro.hero.noteMultilingual': 'Multilingual voices',
  'muse.intro.hero.noteApi': 'API access',
  'muse.intro.hero.chipVoice': 'Voice clone · 30s',
  'muse.intro.hero.chipVideo': 'Avatar video · 4K',
  'muse.intro.hero.chipLang': '20+ languages & voices',
  'muse.intro.hero.nowPlaying': 'Brand film · digital human voice-over',
  'muse.intro.feature.title': 'One platform for AI creation',
  'muse.intro.feature.subtitle': 'Voice, avatars, video and APIs, connected around content production.',
  'muse.intro.feature.tts': 'Voice synthesis',
  'muse.intro.feature.ttsDesc': 'Turn text into natural, ready-to-use voice-over.',
  'muse.intro.feature.clone': 'Voice cloning',
  'muse.intro.feature.cloneDesc': 'Clone a signature voice from a short recording.',
  'muse.intro.feature.template': 'Voice templates',
  'muse.intro.feature.templateDesc': 'Pick the right voice from a curated library.',
  'muse.intro.feature.avatar': 'Digital avatars',
  'muse.intro.feature.avatarDesc': 'Manage platform and custom avatars in one place.',
  'muse.intro.feature.video': 'Avatar video',
  'muse.intro.feature.videoDesc': 'Text or audio driven, generated in minutes.',
  'muse.intro.feature.lang': 'Multilingual',
  'muse.intro.feature.langDesc': 'Voices and lip sync across languages.',
  'muse.intro.feature.api': 'API access',
  'muse.intro.feature.apiDesc': 'Call voice and video synthesis by task.',
  'muse.intro.feature.task': 'Task management',
  'muse.intro.feature.taskDesc': 'Track jobs, status and usage at a glance.',
  'muse.intro.voice.title': 'One script, a thousand voices',
  'muse.intro.voice.desc': 'Hand {name} your copy and get usable voice-over in seconds. Clone your own voice to keep a consistent brand sound.',
  'muse.intro.voice.bullet1': 'Synthesis and cloning share one workflow',
  'muse.intro.voice.bullet2': 'Filter templates by scenario and preview instantly',
  'muse.intro.voice.bullet3': 'Built for long scripts and multiple languages',
  'muse.intro.voice.cta': 'Start synthesizing',
  'muse.intro.voice.tag': 'Voice workspace',
  'muse.intro.voice.track': 'Brand film · voice-over',
  'muse.intro.video.title': 'Let a digital human take the screen',
  'muse.intro.video.desc': 'Pick an avatar, upload a script or audio, and the system handles lip sync, expression and composition to deliver a publish-ready video.',
  'muse.intro.video.bullet1': 'Platform and custom avatars managed together',
  'muse.intro.video.bullet2': 'Driven by text or audio',
  'muse.intro.video.bullet3': 'Track progress and results in one place',
  'muse.intro.video.cta': 'Create a video',
  'muse.intro.video.tag': 'Avatar video',
  'muse.intro.stats.cloneValue': '30s',
  'muse.intro.stats.cloneLabel': 'to clone a voice',
  'muse.intro.stats.qualityValue': '4K',
  'muse.intro.stats.qualityLabel': 'avatar video output',
  'muse.intro.stats.langValue': '20+',
  'muse.intro.stats.langLabel': 'languages & voices',
  'muse.intro.ways.title': 'Flexible ways to integrate',
  'muse.intro.ways.subtitle': 'From team creation to product integration, use {name} your way.',
  'muse.intro.ways.webTitle': 'Web workspace',
  'muse.intro.ways.webDesc': 'Create voice, avatars and videos in the browser, built for content teams.',
  'muse.intro.ways.apiTitle': 'API access',
  'muse.intro.ways.apiDesc': 'Bring voice synthesis and avatar video into your product and workflows.',
  'muse.intro.ways.customTitle': 'Enterprise customization',
  'muse.intro.ways.customDesc': 'Tailor voices, avatars and workflows to your brand and production needs.',
  'muse.intro.ways.action': 'Learn more',
  'muse.intro.final.title': 'Hand your ideas to {name}',
  'muse.intro.final.desc': 'Start with a single line and generate your own voice and digital human video.',
  'muse.intro.final.button': 'Get started',
  'muse.intro.footer.product': 'Product',
  'muse.intro.footer.voice': 'Voice synthesis',
  'muse.intro.footer.video': 'Avatar video',
  'muse.intro.footer.api': 'API access',
  'muse.intro.footer.copyright': '© {year} {name}',

  // Common
  'muse.type.soundTts': 'Voice Synthesis',
  'muse.type.soundClone': 'Voice Clone',
  'muse.type.videoGen': 'Avatar Generation',
  'muse.status.queue': 'Queued',
  'muse.status.process': 'Processing',
  'muse.status.success': 'Success',
  'muse.status.fail': 'Failed',
  'muse.uploadAudio': 'Upload audio',
  'muse.uploadVideo': 'Upload video',
  'muse.audio.uploadHint': 'Click or drag an audio file here to upload',
  'muse.audio.untitled': 'Untitled audio',
  'muse.audio.reupload': 'Click to change the audio',
  'muse.uploading': 'Uploading...',
  'muse.play': 'Play',
  'muse.delete': 'Delete',
  'muse.edit': 'Edit',
  'muse.confirmDelete': 'Delete this item?',

  // Dashboard
  'muse.dashboard.title': 'Dashboard',
  'muse.dashboard.statTotal': 'Total tasks',
  'muse.dashboard.statSuccess': 'Succeeded',
  'muse.dashboard.statFail': 'Failed',
  'muse.dashboard.statConsumed': 'Credits consumed',
  'muse.dashboard.statUsers': 'Users',

  // Tasks (admin)
  'muse.task.title': 'Tasks',
  'muse.task.colId': 'ID',
  'muse.task.colUser': 'User',
  'muse.task.colType': 'Type',
  'muse.task.colModel': 'Model',
  'muse.task.colTitle': 'Title',
  'muse.task.colStatus': 'Status',
  'muse.task.colCredit': 'Credits',
  'muse.task.colCreatedAt': 'Time',
  'muse.task.colAction': 'Actions',
  'muse.task.searchPlaceholder': 'Search title / model',
  'muse.task.empty': 'No tasks',
  'muse.task.typeAll': 'All types',
  'muse.task.statusAll': 'All statuses',
  'muse.task.deleteSuccess': 'Deleted',
  'muse.task.deleteFailed': 'Delete failed',
  'muse.task.detail': 'Details',
  'muse.task.detailTitle': 'Task Details',
  'muse.task.copy': 'Copy',
  'muse.task.copied': 'Copied',
  'muse.task.fieldUser': 'User',
  'muse.task.fieldType': 'Type',
  'muse.task.fieldModel': 'Model',
  'muse.task.fieldTitle': 'Title',
  'muse.task.fieldStatus': 'Status',
  'muse.task.fieldCredit': 'Credits',
  'muse.task.fieldCreatedAt': 'Created',
  'muse.task.fieldRemoteTaskId': 'Remote task ID',
  'muse.task.fieldChainTaskId': 'Chain task ID',
  'muse.task.fieldStatusRemark': 'Failure reason',
  'muse.task.request': 'Request',
  'muse.task.requestEmpty': 'No request',
  'muse.task.result': 'Result',
  'muse.task.resultEmpty': 'No result',
  'muse.task.resultUrl': 'Result URL',
  'muse.task.none': 'None',
  'muse.task.userInfoTitle': 'User Info',
  'muse.task.userBasic': 'Basic Info',
  'muse.task.userId': 'User ID',
  'muse.task.username': 'Username',
  'muse.task.userEmail': 'Email',
  'muse.task.userNoEmail': 'No email bound',
  'muse.task.userRole': 'Role',
  'muse.task.userStatus': 'Status',
  'muse.task.userCredit': 'Credits',
  'muse.task.userCreatedAt': 'Registered',
  'muse.task.editUser': 'Edit',
  'muse.task.adjustCredit': 'Adjust credits',
  'muse.task.roleAdmin': 'Admin',
  'muse.task.roleUser': 'User',
  'muse.task.statusNormal': 'Active',
  'muse.task.statusDisabled': 'Disabled',
  'muse.task.userLoadFailed': 'Failed to load user info',

  // Model config
  'muse.model.title': 'API Config',
  'muse.model.credTitle': 'Service Credentials',
  'muse.model.guideBefore': 'Go to ',
  'muse.model.guideAfter': ' to register and create an app, then copy the AppId and AppSecret from the app details. The service URL defaults to https://api.tecmz.com/open_api and usually needs no change.',
  'muse.model.baseUrl': 'Service URL',
  'muse.model.appId': 'AppId',
  'muse.model.appSecret': 'AppSecret',
  'muse.model.ping': 'Test connection',
  'muse.model.pingOk': 'Connected',
  'muse.model.pingFailed': 'Connection failed',
  'muse.model.saved': 'Saved',
  'muse.model.saveFailed': 'Save failed',

  // Avatars (admin)
  'muse.avatarPreset.title': 'Platform Avatars',
  'muse.avatarPreset.enabled': 'Enabled',
  'muse.avatarPreset.disabled': 'Disabled',
  'muse.avatarPreset.add': 'Add avatar',
  'muse.avatarPreset.edit': 'Edit avatar',
  'muse.avatarPreset.empty': 'No avatars',
  'muse.avatarPreset.name': 'Name',
  'muse.avatarPreset.namePlaceholder': 'e.g. Default female host',
  'muse.avatarPreset.video': 'Avatar video',
  'muse.avatarPreset.needVideo': 'Upload an avatar video first',
  'muse.avatarPreset.uploadHint': 'Uploading a video snaps the 1s frame as the cover',
  'muse.avatarPreset.uploadSuccess': 'Uploaded',
  'muse.avatarPreset.uploadFailed': 'Upload failed',
  'muse.avatarPreset.model': 'Cloud model name',
  'muse.avatarPreset.enable': 'Enabled',
  'muse.avatarPreset.saveSuccess': 'Saved',
  'muse.avatarPreset.saveFailed': 'Save failed',
  'muse.avatarPreset.deleteSuccess': 'Deleted',
  'muse.avatarPreset.deleteFailed': 'Delete failed',

  // Voice templates (user)
  'muse.voiceTemplate.title': 'Voice Templates',
  'muse.voiceTemplate.desc': 'Create synthesis / clone templates, then pick one when synthesizing',
  'muse.voiceTemplate.create': 'New',
  'muse.voiceTemplate.createGuide': 'New voice template',
  'muse.voiceTemplate.edit': 'Edit',
  'muse.voiceTemplate.empty': 'No templates',
  'muse.voiceTemplate.type': 'Template type',
  'muse.voiceTemplate.typeTtsDesc': 'Pick a cloud voice and synthesize',
  'muse.voiceTemplate.typeCloneDesc': 'Upload a sample to clone the voice',
  'muse.voiceTemplate.name': 'Template name',
  'muse.voiceTemplate.namePlaceholder': 'e.g. My voice',
  'muse.voiceTemplate.modelKey': 'Model',
  'muse.voiceTemplate.param': 'Parameters',
  'muse.voiceTemplate.speaker': 'Voice',
  'muse.voiceTemplate.pickSpeaker': 'Select voice',
  'muse.voiceTemplate.refAudio': 'Reference audio',
  'muse.voiceTemplate.refAudioHint': 'Upload a clear voice sample as the reference audio',
  'muse.voiceTemplate.refText': 'Reference text',
  'muse.voiceTemplate.refTextPlaceholder': 'Text of the audio (optional, improves quality)',
  'muse.voiceTemplate.speed': 'Speed',
  'muse.voiceTemplate.copyId': 'Click to copy ID',
  'muse.voiceTemplate.copied': 'Copied',
  'muse.voiceTemplate.uploadSuccess': 'Uploaded',
  'muse.voiceTemplate.createSuccess': 'Created',
  'muse.voiceTemplate.createFailed': 'Create failed',
  'muse.voiceTemplate.updateSuccess': 'Updated',
  'muse.voiceTemplate.updateFailed': 'Update failed',
  'muse.voiceTemplate.deleteSuccess': 'Deleted',
  'muse.voiceTemplate.deleteFailed': 'Delete failed',
  'muse.voiceTemplate.needAudio': 'Please upload a reference audio first',
  'muse.voiceTemplate.needSpeaker': 'Please select a voice first',
  'muse.voiceTemplate.needModel': 'Please select a clone model first',

  // Speaker catalog (cloud)
  'muse.speaker.search': 'Search voice name',
  'muse.speaker.allLangs': 'All languages',
  'muse.speaker.allModels': 'All models',
  'muse.speaker.empty': 'No voices',
  'muse.speaker.loadFailed': 'Failed to load voices',
  'muse.speaker.select': 'Select',
  'muse.speaker.selected': 'Selected',
  'muse.speaker.preview': 'Preview',
  'muse.speaker.previewing': 'Previewing',
  'muse.speaker.current': 'Current voice',
  'muse.speaker.pickHint': 'Click a card to pick a voice',
  'muse.speaker.previewHint': 'Click ▶ to preview',
  'muse.speaker.clearFilters': 'Clear filters',
  'muse.speaker.total': '{total} voices',

  // Voice synthesis (user)
  'muse.voice.title': 'Voice Synthesis',
  'muse.voice.template': 'Voice template',
  'muse.voice.pickerTitle': 'Select voice',
  'muse.voice.pickSpeaker': 'Select voice',
  'muse.voice.emptyTemplate': 'No voice templates yet, create one in Voice Templates',
  'muse.voice.goTemplate': 'Create',
  'muse.voice.text': 'Text',
  'muse.voice.textPlaceholder': 'Enter the text to synthesize',
  'muse.voice.adjustParam': 'Adjust params',
  'muse.voice.paramHint': 'Defaults to the template params; override for this synthesis',
  'muse.voice.submit': 'Synthesize',
  'muse.voice.submitSuccess': 'Task submitted',
  'muse.voice.submitFailed': 'Submit failed',
  'muse.voice.needText': 'Please enter the text',
  'muse.voice.needTemplate': 'Please select a voice template first',
  'muse.voice.balance': 'Credits',
  'muse.voice.history': 'History',
  'muse.voice.empty': 'No synthesis records',
  'muse.voice.emptyFiltered': 'No records match the filters',
  'muse.voice.previewPending': 'Preview appears here once synthesized',
  'muse.voice.creditCost': '{n} credits',
  'muse.voice.copyId': 'Click to copy ID',
  'muse.voice.copied': 'Copied',
  'muse.voice.untitled': 'Untitled',
  'muse.voice.download': 'Download',
  'muse.voice.deleteSuccess': 'Deleted',
  'muse.voice.deleteFailed': 'Delete failed',
  'muse.voice.synthRunning': 'Synthesizing, preview when ready',
  'muse.voice.failNoReason': 'Synthesis failed, please retry',
  'muse.voice.retry': 'Retry',
  'muse.voice.resynthesize': 'Synthesize again',
  'muse.voice.copyText': 'Copy text',
  'muse.voice.copyLink': 'Copy link',
  'muse.voice.textCopied': 'Text copied',
  'muse.voice.linkCopied': 'Link copied',
  'muse.voice.refilled': 'Text filled in, ready to synthesize',
  'muse.voice.noTextToReuse': 'No reusable text in this record',
  'muse.voice.loadMore': 'Load more',
  'muse.voice.allLoaded': 'All records loaded',
  'muse.voice.filterTypeAll': 'All types',
  'muse.voice.filterStatusAll': 'All statuses',

  // Avatars (user)
  'muse.avatar.title': 'Avatars',
  'muse.avatar.desc': 'Manage platform presets and my uploaded avatars',
  'muse.avatar.myAvatars': 'My avatars',
  'muse.avatar.presets': 'Platform avatars',
  'muse.avatar.create': 'New avatar',
  'muse.avatar.empty': 'No avatars',
  'muse.avatar.name': 'Avatar name',
  'muse.avatar.namePlaceholder': 'e.g. My avatar',
  'muse.avatar.video': 'Avatar video',
  'muse.avatar.uploadHint': 'Click to upload the original video you captured',
  'muse.avatar.uploadSuccess': 'Uploaded',
  'muse.avatar.standardTitle': 'Standard examples',
  'muse.avatar.standRef': 'Standing pose',
  'muse.avatar.sitRef': 'Sitting pose',
  'muse.avatar.rule1': 'At least 8 seconds long, with clear articulation;',
  'muse.avatar.rule2': 'Only the same single person appears throughout;',
  'muse.avatar.rule3': 'Facial features clear and unobstructed, head not tilted or turned, hands away from the face, mouth and neck;',
  'muse.avatar.rule4': 'Resolution of at least 720P;',
  'muse.avatar.rule5': 'Format MP4 / MOV.',
  'muse.avatar.errorTitle': 'Wrong examples',
  'muse.avatar.errMultiFace': 'Multiple faces',
  'muse.avatar.errBigFace': 'Face too large',
  'muse.avatar.errNoFace': 'No face detected',
  'muse.avatar.errOccluded': 'Features occluded',
  'muse.avatar.createSuccess': 'Created',
  'muse.avatar.createFailed': 'Create failed',
  'muse.avatar.edit': 'Edit avatar',
  'muse.avatar.updateSuccess': 'Updated',
  'muse.avatar.updateFailed': 'Update failed',
  'muse.avatar.deleteSuccess': 'Deleted',
  'muse.avatar.deleteFailed': 'Delete failed',
  'muse.avatar.needVideo': 'Please upload an avatar video first',
  'muse.avatar.download': 'Download',
  'muse.avatar.copyId': 'Click to copy ID',
  'muse.avatar.copied': 'Copied',
  'muse.avatar.noVideo': 'No video',
  'muse.avatar.videoUnavailable': 'Video unavailable',

  // Avatar generation (user)
  'muse.avatarGenerate.title': 'Avatar Generation',
  'muse.avatarGenerate.avatar': 'Avatar',
  'muse.avatarGenerate.model': 'Model',
  'muse.avatarGenerate.modelPlaceholder': 'Select a generation model',
  'muse.avatarGenerate.audio': 'Driving audio',
  'muse.avatarGenerate.driverText': 'Enter text',
  'muse.avatarGenerate.driverTextDesc': 'Pick a voice template and type text',
  'muse.avatarGenerate.driverUpload': 'Upload audio',
  'muse.avatarGenerate.driverUploadDesc': 'Upload a local audio file',
  'muse.avatarGenerate.driverSelect': 'Select audio',
  'muse.avatarGenerate.driverSelectDesc': 'Pick audio from synthesis history',
  'muse.avatarGenerate.voicePlaceholder': 'Select a voice template',
  'muse.avatarGenerate.textPlaceholder': 'Enter the text to synthesize',
  'muse.avatarGenerate.noVoice': 'No voice template yet; create one in "Voice Templates" first',
  'muse.avatarGenerate.uploadHint': 'Pick a local audio file as the driving audio',
  'muse.avatarGenerate.uploadSuccess': 'Uploaded',
  'muse.avatarGenerate.reupload': 'Click to change the audio',
  'muse.avatarGenerate.selectHint': 'Pick an audio from the history of the "Voice Synthesis" page',
  'muse.avatarGenerate.reselect': 'Click to change the audio',
  'muse.avatarGenerate.pickerTitle': 'Select audio',
  'muse.avatarGenerate.pickerEmpty': 'No synthesized audio',
  'muse.avatarGenerate.pickerSelect': 'Select',
  'muse.avatarGenerate.titleField': 'Title',
  'muse.avatarGenerate.titlePlaceholder': 'Optional, to tell works apart',
  'muse.avatarGenerate.submit': 'Generate',
  'muse.avatarGenerate.submitSuccess': 'Task submitted',
  'muse.avatarGenerate.submitFailed': 'Submit failed',
  'muse.avatarGenerate.needAudio': 'Please provide the driving audio',
  'muse.avatarGenerate.needAvatar': 'Please select an avatar',
  'muse.avatarGenerate.needModel': 'Please select a generation model',
  'muse.avatarGenerate.needText': 'Please enter the driving text',
  'muse.avatarGenerate.needVoice': 'Please select a voice template',
  'muse.avatarGenerate.history': 'History',
  'muse.avatarGenerate.empty': 'No generation records',
  'muse.avatarGenerate.download': 'Download video',
  'muse.avatarGenerate.untitled': 'Untitled',
  'muse.avatarGenerate.copyId': 'Click to copy ID',
  'muse.avatarGenerate.copied': 'Copied',
  'muse.avatarGenerate.noAvatar': 'No avatar available',
  'muse.avatarGenerate.noAvatarHint': 'Add one in "Avatar" first',
  'muse.avatarGenerate.goAvatar': 'Add',

  // Home (user workspace)
  'muse.home.title': 'Workspace',
  'muse.home.overview.title': 'Overview',
  'muse.home.overview.updateAt': 'Updated {time}',
  'muse.home.overview.voice': 'Voice Synthesis',
  'muse.home.overview.clone': 'Voice Clone',
  'muse.home.overview.avatar': 'Avatar',
  'muse.home.overview.video': 'Avatar Video',
  'muse.home.overview.today': 'Today {value}',
  'muse.home.quick.voiceTitle': 'Voice Synthesis',
  'muse.home.quick.voiceDesc': 'Type text and pick a voice template to synthesize natural speech',
  'muse.home.quick.voiceAction': 'Synthesize',
  'muse.home.quick.cloneTitle': 'Voice Clone',
  'muse.home.quick.cloneDesc': 'Upload a reference audio to clone a custom voice in 20 seconds',
  'muse.home.quick.cloneAction': 'Clone',
  'muse.home.quick.avatarTitle': 'Avatar Video',
  'muse.home.quick.avatarDesc': 'Pick an avatar and drive it with audio or text to generate a video',
  'muse.home.quick.avatarAction': 'Generate',
  'muse.home.wallet.title': 'My Wallet',
  'muse.home.wallet.balance': 'Credit Balance',
  'muse.home.wallet.todayUsed': 'Used Today',
  'muse.home.wallet.recharge': 'Top Up',
  'muse.home.trend.voiceTitle': 'Voice Synthesis',
  'muse.home.trend.videoTitle': 'Avatar Video',
  'muse.home.trend.voiceSeries': 'Syntheses',
  'muse.home.trend.videoSeries': 'Generations',
  'muse.home.trend.range': 'Last 14 days',
  'muse.home.trend.empty': 'No data in the last 14 days',
  'muse.home.loadFailed': 'Failed to load data',
  // Dashboard extras / task retry / form details
  'muse.dashboard.statToday': 'Today',
  'muse.dashboard.statConsumedUnit': 'Successful tasks only',
  'muse.dashboard.statUsersHint': 'Total registered users',
  'muse.dashboard.trendTitle': 'Task trend',
  'muse.dashboard.trendRange': 'Last 14 days',
  'muse.dashboard.trendEmpty': 'No tasks in the last 14 days',
  'muse.dashboard.trendSeries': 'Tasks',
  'muse.dashboard.typeTitle': 'Type breakdown',
  'muse.dashboard.successRate': 'Success rate',
  'muse.dashboard.successRateHint': 'Success {success} · Failed {fail}',
  'muse.dashboard.recentTitle': 'Recent tasks',
  'muse.dashboard.recentEmpty': 'No tasks yet',
  'muse.dashboard.viewAll': 'View all',
  'muse.dashboard.quickTitle': 'Shortcuts',
  'muse.dashboard.quickTask': 'Tasks',
  'muse.dashboard.quickPreset': 'Platform avatars',
  'muse.dashboard.quickModel': 'API settings',
  'muse.dashboard.channelTitle': 'Channel performance',
  'muse.dashboard.channelSummary': '{registers} registrations · {activated} activated',
  'muse.dashboard.channelColChannel': 'Channel',
  'muse.dashboard.channelColRegisters': 'Signups',
  'muse.dashboard.channelColActivated': 'Activated',
  'muse.dashboard.channelColRate': 'Activation rate',
  'muse.dashboard.channelColTasks': 'Tasks',
  'muse.dashboard.channelColConsumed': 'Consumed',
  'muse.dashboard.channelEmpty': 'No channel data yet',
  'muse.voice.fillExample': 'Fill example',
  'muse.voice.exampleText': 'Welcome to digital human voice-over. This is a sample sentence for previewing the voice.',
  'muse.avatarGenerate.retry': 'Retry',
  'muse.avatarGenerate.retrySubmitted': 'Resubmitted, check the record for progress',
  'muse.avatarGenerate.retryFailed': 'Retry failed',
  'muse.model.unchanged': 'No unsaved changes',
  'muse.model.lastPing': 'Last test: {result} · {time}',
  'muse.model.lastPingEmpty': 'Connection not tested yet',
  'muse.home.overview.cumulative': 'cumulative',
  'muse.task.resetFilter': 'Reset filters',
  'muse.home.trend.unit': 'times',
  'muse.voiceTemplate.submitHint': 'Fill in the name and choose a voice or upload reference audio',
  'muse.pricing.title': 'Billing settings',
  'muse.pricing.typeTitle': 'Price by type',
  'muse.pricing.typeDesc': 'Leave blank to inherit the cloud catalog price. Unit size means how many characters / minutes make one billing unit.',
  'muse.pricing.cloudPrice': 'Cloud price',
  'muse.pricing.price': 'Unit price (credits)',
  'muse.pricing.unitSize': 'Unit size',
  'muse.pricing.inherit': 'Inherit cloud',
  'muse.pricing.unitText': 'per {n} characters',
  'muse.pricing.unitMinute': 'per minute',
  'muse.pricing.unitCount': 'per task',
  'muse.pricing.modelTitle': 'Override by model',
  'muse.pricing.modelDesc': 'Models of the same type can be priced separately; an override takes precedence over the type price above.',
  'muse.pricing.catalogEmpty': 'The cloud model catalog is unavailable. Check the model service credentials in API settings.',
  'muse.pricing.colModel': 'Model',
  'muse.pricing.colType': 'Type',
  'muse.pricing.noticeTitle': 'Billing notice',
  'muse.pricing.noticeDesc': 'Shown in the submit area of both Voice Synthesis and Avatar Generation, which share the same content.',
  'muse.pricing.noticeReset': 'Restore default',
  'muse.pricing.saved': 'Saved',
  'muse.pricing.saveFailed': 'Save failed',
  'muse.pricing.unchanged': 'No unsaved changes',
}
